// https://gist.github.com/fiznool/73ee9c7a11d1ff80b81c

const ALPHABET = '23456789abdegjkmnpqrvwxyzABDEGJKMNPQRVWXYZ';
const ID_LENGTH = 9;

export function generateHash() {
  let rtn = '';
  for (let i = 0; i < ID_LENGTH; i++) {
    rtn += ALPHABET.charAt(Math.floor(Math.random() * ALPHABET.length));
  }
  return rtn;
}



// WEBPACK FOOTER //
// ./src/helpers/hashId.ts